import { useWatch, type UseFormReturn } from 'react-hook-form'
import type { ContactEntityType, GovernmentId } from 'types/contacts'
import type { ContactFormData } from '../schemas/contactSchema'
import { createEmptyGovernmentId, getGovernmentIdsForEntityType } from '../utils/governmentIds'

export const useGovernmentIds = ({
  control,
  setValue,
  clearErrors,
}: UseFormReturn<ContactFormData>) => {
  const governmentIds = useWatch({ control, name: 'governmentIds' }) ?? []

  const setGovernmentIds = (updatedGovernmentIds: GovernmentId[]) => {
    clearErrors('governmentIds')
    setValue('governmentIds', updatedGovernmentIds, { shouldDirty: true })
  }

  const onAddGovernmentId = () => {
    setGovernmentIds([...governmentIds, createEmptyGovernmentId()])
  }

  const onChangeGovernmentId = (index: number, governmentId: GovernmentId) => {
    setGovernmentIds(
      governmentIds.map((currentGovernmentId, currentIndex) =>
        currentIndex === index ? governmentId : currentGovernmentId
      )
    )
  }

  const onRemoveGovernmentId = (index: number) => {
    setGovernmentIds(governmentIds.filter((_, currentIndex) => currentIndex !== index))
  }

  const onResetGovernmentIds = () => {
    setValue('governmentIds', [])
    clearErrors('governmentIds')
  }

  const onChangeGovernmentIdsEntityType = (entityType: ContactEntityType) => {
    if (governmentIds.length > 0) {
      setGovernmentIds(getGovernmentIdsForEntityType(governmentIds, entityType))
    }
  }

  return {
    governmentIds,
    onAddGovernmentId,
    onChangeGovernmentId,
    onRemoveGovernmentId,
    onResetGovernmentIds,
    onChangeGovernmentIdsEntityType,
  }
}
